import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { logger } from "#app/monitoring/Logger";
import { ApiError } from "#shared/infra/apiError";

export type UpdateQuoteRequestDto = ClientInferRequest<
  typeof contract.quoteRequests.update
>["body"];
export type QuoteRequestDto = ClientInferResponseBody<typeof contract.quoteRequests.update>;
const schema = contract.quoteRequests.update.responses[200];

export const updateQuoteRequest = async ({
  id,
  quoteRequest,
}: {
  id: string | undefined;
  quoteRequest: UpdateQuoteRequestDto;
}): Promise<QuoteRequestDto> => {
  if (!id) {
    throw new Error("quoteRequestId is undefined");
  }

  const response = await api.quoteRequests.update.mutation({
    params: {
      id,
    },
    body: {
      ...quoteRequest,
    },
  });

  if (response.status !== 200) {
    throw new ApiError("Error updating quote request", response.status, response.body);
  }

  const parsedResponse = schema.safeParse(response.body);

  if (!parsedResponse.success) {
    logger.error(`Error updating quote request line ${id}`);

    return response.body;
  }

  return parsedResponse.data;
};
